import { CanMatchFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { Identity } from '../models/api/identity';
import { IdentityService } from '../services/identity.service';
import { TenantReducerUtils } from '../utils/reducers/tenant-reducer.utils';
import { map, Observable } from 'rxjs';

export const canMatchTenantManagement: CanMatchFn = (): Observable<boolean | UrlTree> => {
  const router: Router = inject(Router);
  const identityService: IdentityService = inject(IdentityService);

  return identityService.getIdentity().pipe(
    map((identity: Identity) =>
      TenantReducerUtils.isAdminMode(identity) || router.createUrlTree([''])
    ),
  );
};
